import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-activity-type-langs',
  templateUrl: './activity-type-langs.component.html',
  styleUrls: ['./activity-type-langs.component.css']
})
export class ActivityTypeLangsComponent implements OnInit {
    activityTypeNo;

    public inputListLanguages: InputLanguageItem[] = [];

    public saving = false;

    constructor(private state: StateService, private datatask: DataTaskService) {
        this.activityTypeNo = this.state.getStateParams()['activitytype_no'];
    }

    private async loadLanguages() {
        if (!!this.activityTypeNo) {
            this.inputListLanguages = (await this.datatask.Post(1238, { activitytype_no: this.activityTypeNo }));
    	}
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(1239, { records: this.inputListLanguages });

                this.state.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }

}

interface InputLanguageItem {
    activitytype_no: string;
    activitytype_lang_name: string;
    language_id: string;
    language_name: string;
    orderby: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('activityTypeLangs', {
//        templateUrl: 'views/components/views/activityTypeLangs/activityTypeLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'activityTypeLangsService', function ($stateParams, stateService, translateService, modalService, activityTypeLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let activityTypeNo = $stateParams.activitytype_no;

//            let translations = {
//                confirmation: '',
//                ok: ''
//            };

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await activityTypeLangsService.listLanguages({ activitytype_no: activityTypeNo });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                activityTypeLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function (response) {
//                    if (response[0].ws_result === '1') {
//                        modalService.show({
//                            type: 'success',
//                            title: translations.confirmation,
//                            message: response[0].ws_result_message,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-success',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                    stateService.back();
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
